module.exports = __webpack_public_path__ + "static/media/ganeshs.f252f7b3.png";